/* Landing ELLA FREELANCE: las secciones aparecen suavemente al bajar. Sin JS todo se ve igual. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = document.querySelectorAll(
    '.ella-section .ella-wrap > *, .ella-cards__item, .ella-ig, .ella-pages__item, .ella-cta__inner'
  );
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  for (const el of targets) {
    if (el.getBoundingClientRect().top < window.innerHeight) continue;
    el.classList.add('ella-reveal');
    observer.observe(el);
  }
})();

/* Video de la historia: quieto si la persona pidió reducir movimiento. */
(() => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  for (const video of document.querySelectorAll('.ella-story-bg video')) {
    video.removeAttribute('autoplay');
    video.pause();
  }
})();
